import initStore from '../store';

export const { store, persistor, persistedReducer, sagaMiddleware, sagas } = initStore();
